import { consume } from "@lit/context";
import { OrderManagementContext, orderManagementContextKey } from "../order-management.context";
import { html, LitElement, nothing, PropertyValues } from "lit";
import { classMap } from "lit/directives/class-map.js";
import { customElement, state } from "lit/decorators.js";
import { BasketDateLine } from "../../cart.types";

@customElement("basket-button")
export class BasketButtonElement extends LitElement {
    @consume({ context: orderManagementContextKey, subscribe: true })
    @state()
    private orderManagementContext? : OrderManagementContext | null = null;

    private _basketLineSubscription: import("rxjs").Subscription | undefined;
    private _itemAddedSubscription: import("rxjs").Subscription | undefined;

    @state()
    private basketLines: BasketDateLine[] = [];

    @state()
    private animateCart: boolean = false;

    public override connectedCallback() {
        super.connectedCallback();

        this._basketLineSubscription = this.orderManagementContext?.basketLines$.subscribe({ next: (next) => this.basketLines = next });

        this._itemAddedSubscription = this.orderManagementContext?.basketItemAdded$.subscribe({ next: () => {
            this.animateCart = true;
            setTimeout(() => {
                this.animateCart = false;
            }, 600);
        } });
    }


    public override updated(_changedProperties: PropertyValues): void {
        super.updated(_changedProperties);

        if(_changedProperties.has("orderManagementContext")) {
            if(this._basketLineSubscription) {
                this._basketLineSubscription.unsubscribe();
                this._itemAddedSubscription?.unsubscribe();
            }
            this._basketLineSubscription = this.orderManagementContext?.basketLines$.subscribe({ next: (next) => this.basketLines = next });
            this._itemAddedSubscription = this.orderManagementContext?.basketItemAdded$.subscribe({ next: () => {
                this.animateCart = true;
                setTimeout(() => {
                    this.animateCart = false;
                }, 600);
            } });
        }
    }

    protected override render() {
        const buttonClasses = {
            "animate-cart-bounce": this.animateCart,
        }

        return html`
            <button class="${classMap(buttonClasses)} relative cursor-pointer rounded-lg transition text-white bg-mcr-purple hover:text-mcr-purple hover:bg-white" @click=${this.handleButtonClick}>
                <svg class="size-10 p-1 rounded">
                    <use href="#cart-icon" />
                </svg>
                ${this.basketLines.length > 0 ? html`
                <div class="absolute -top-1 -right-1 flex w-full h-full justify-end items-start">
                    <span role="status" aria-live="polite" class="text-mcr-opal-400 text-xs leading-3 rounded-full aspect-square flex items-center justify-center px-2 pb-0.5 bg-mcr-opal-800">${this.calculateNumber()}</span>
                </div>
                ` : nothing}
            </button>`;
    }

    protected override createRenderRoot() {
        return this;
    }

    private handleButtonClick() {
        this.dispatchEvent(new CustomEvent("basket-button-clicked", { bubbles: true, composed: true }));
    }

    private calculateNumber() {
        return this.basketLines.reduce((total, line) =>
            total + line.details.reduce((lineTotal, detail) =>
                lineTotal + detail.orderLines.reduce((orderLineTotal, orderLine) => orderLineTotal + (orderLine.quantity ?? 0), 0), 0), 0);
    }
}